import { getContrastColor } from "utils/utils";

/** Color hex -> rgba (helper reutilizable). */
export const hexToRgba = (hex, alpha = 1) => {
	if (!hex || typeof hex !== "string") return `rgba(0, 0, 0, ${alpha})`;

	let h = hex.replace("#", "").trim();
	if (h.length === 3) {
		h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
	}
	if (h.length !== 6) return `rgba(0, 0, 0, ${alpha})`;

	const r = parseInt(h.substring(0, 2), 16);
	const g = parseInt(h.substring(2, 4), 16);
	const b = parseInt(h.substring(4, 6), 16);
	return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/** Turno con color blanco (o casi): pill con borde gris y texto oscuro vía CSS */
export const isWhiteShiftColor = (value) => {
	if (!value || typeof value !== "string") return false;
	const v = value.trim().toLowerCase();
	if (v === "white" || v === "#fff" || v === "#ffffff") return true;
	const rgb = v.match(
		/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i
	);
	if (rgb) {
		const r = Number(rgb[1]);
		const g = Number(rgb[2]);
		const b = Number(rgb[3]);
		return r >= 250 && g >= 250 && b >= 250;
	}
	let h = v.replace("#", "");
	if (h.length === 3) {
		h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
	}
	if (h.length !== 6 || !/^[0-9a-f]+$/i.test(h)) return false;
	const r = parseInt(h.substring(0, 2), 16);
	const g = parseInt(h.substring(2, 4), 16);
	const b = parseInt(h.substring(4, 6), 16);
	if (Number.isNaN(r) || Number.isNaN(g) || Number.isNaN(b)) return false;
	return r >= 250 && g >= 250 && b >= 250;
};

const getPillTextColor = (color) => {
	if (!color || typeof color !== "string") return "black";
	const value = color.trim();

	// Reutilizamos la utilidad común cuando es hex o nombre simple.
	if (!value.startsWith("rgb")) {
		return getContrastColor(value, "black");
	}

	// Soporte para rgb()/rgba() en caso de que llegue desde backend.
	const rgb = value.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i);
	if (!rgb) return "black";
	const r = Number(rgb[1]);
	const g = Number(rgb[2]);
	const b = Number(rgb[3]);
	const yiq = (r * 299 + g * 587 + b * 114) / 1000;
	return yiq >= 128 ? "black" : "white";
};

/**
 * Estilos inline del pill (fondo sólido, texto por contraste). Soporta #hex y rgb()/rgba().
 */
export const getShiftPillVisuals = (color) => {
	const fallback = "#5b49fe";
	const raw = color != null && String(color).trim() !== "" ? String(color).trim() : "";
	const accent = raw || fallback;

	return {
		pillOnWhite: isWhiteShiftColor(accent),
		style: {
			backgroundColor: accent,
			color: getPillTextColor(accent),
		},
	};
};
